import React, { memo, useState } from 'react';
import Link from 'next/link';

import {
  List,
  ListTitle,
  ListTitleContainer,
  SubList,
  SubListItem,
} from './styles';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { ICollapsibleMenuProductItem } from './model';
import { useTheme } from '@mui/material/styles';
import { ListItemText, Stack, Typography } from '@mui/material';
import { Button } from '@core/design-system/button';
import { StyledList, StyledListItem } from '../navbar/styles';

export const CollapsibleMenuProductItem = memo<ICollapsibleMenuProductItem>(
  ({ title, items, closeDrawer }) => {
    const theme = useTheme();

    const [opened, setOpened] = useState(false);

    return (
      <List>
        <ListTitleContainer onClick={() => setOpened((state) => !state)}>
          <ListTitle opened={opened}>{title}</ListTitle>
          {opened ? (
            <ChevronUp
              size={20}
              color={theme.palette.secondary.main}
              style={{ marginLeft: 'auto' }}
            />
          ) : (
            <ChevronDown size={20} style={{ marginLeft: 'auto' }} />
          )}
        </ListTitleContainer>

        <SubList opened={opened} sx={{ padding: 0 }}>
          <Stack gap={2} sx={{ padding: '1rem' }}>
            {items.map((item, index) => (
              <Stack maxWidth="230px" key={`menu-${index}`}>
                <Typography
                  variant="caption"
                  color={theme.palette.mediumNeutral.main}
                  fontWeight={600}
                  textTransform="uppercase"
                  lineHeight={1.6}
                  letterSpacing={0.4}
                >
                  {item?.subTitle}
                </Typography>
                <Typography
                  variant="h3"
                  component="p"
                  color={theme.palette.secondary.main}
                  fontWeight={600}
                  lineHeight={1.6}
                  letterSpacing={0.4}
                >
                  {item?.label}
                </Typography>
                <Typography
                  variant="caption"
                  color={theme.palette.primary.contrastText}
                  fontWeight={400}
                  lineHeight={1.6}
                  letterSpacing={0.4}
                >
                  {item?.description}
                </Typography>
                <StyledList>
                  {item.subTitle == 'Para negócios' &&
                    item?.subItems?.map((subitem, index) => (
                      <StyledListItem key={subitem.label} color={'white'}>
                        <Link
                          href={subitem?.link}
                          prefetch={false}
                          target="_blank"
                          rel="noopener"
                          style={{ padding: 0 }}
                        >
                          <ListItemText
                            sx={{
                              '& span': {
                                fontSize: theme.typography.body2.fontSize,
                                fontWeight: 600,
                              },
                            }}
                          >
                            {subitem?.label}
                          </ListItemText>
                        </Link>
                      </StyledListItem>
                    ))}
                </StyledList>
                {item?.link && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    href={item?.link}
                    component="a"
                    LinkComponent={Link}
                    sx={{
                      textTransform: 'none',
                      color: theme.palette.primary.contrastText,
                    }}
                  >
                    {item?.linkLabel}
                  </Button>
                )}
              </Stack>
            ))}
          </Stack>
        </SubList>
      </List>
    );
  }
);
